(function () {
  function initFeaturedTabs(root) {
    if (!root || root.dataset.featuredInit) return;
    root.dataset.featuredInit = '1';

    var tabs = root.querySelectorAll('[data-featured-tab]');
    var panels = root.querySelectorAll('[data-featured-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panelId = tab.getAttribute('aria-controls');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.id === panelId;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-featured-tabs]').forEach(initFeaturedTabs);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-featured-tabs]');
    if (root) {
      delete root.dataset.featuredInit;
      initFeaturedTabs(root);
    }
  });
})();
